import { authenticatedInstance } from '../index/index.service';
import { extractServiceErrorMessage } from '../shared/service-error.util';
import type {
  E2eRunReportView,
  E2eRunStartResponse,
  E2eRunTier,
  E2eRunnerStatusView,
} from 'shared-models/browser';

export type {
  E2eRunActive,
  E2eRunLast,
  E2eRunReportPhase,
  E2eRunReportView,
  E2eRunStartResponse,
  E2eRunTier,
  E2eRunnerStatusView,
} from 'shared-models/browser';

class E2eRunnerService {
  async getStatus(): Promise<E2eRunnerStatusView> {
    try {
      const response = await authenticatedInstance.get<E2eRunnerStatusView>('/e2e-runner/status');
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'טעינת מצב ריצת הבדיקות נכשלה'));
    }
  }

  async listRuns(): Promise<E2eRunReportView[]> {
    try {
      const response = await authenticatedInstance.get<E2eRunReportView[]>('/e2e-runner/runs');
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'טעינת דוחות הבדיקות נכשלה'));
    }
  }

  async start(tier: E2eRunTier, branch: string): Promise<E2eRunStartResponse> {
    try {
      const response = await authenticatedInstance.post<E2eRunStartResponse>('/e2e-runner/start', { tier, branch });
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'הפעלת ריצת הבדיקות נכשלה'));
    }
  }

  async stop(): Promise<void> {
    try {
      await authenticatedInstance.post('/e2e-runner/stop');
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'עצירת ריצת הבדיקות נכשלה'));
    }
  }
}

export const e2eRunnerService = new E2eRunnerService();
